import { render } from "./chapter.vue?vue&type=template&id=504717ed&scoped=true&ts=true"
import script from "./chapter.vue?vue&type=script&lang=ts&setup=true"
export * from "./chapter.vue?vue&type=script&lang=ts&setup=true"

import "./chapter.vue?vue&type=style&index=0&id=504717ed&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504717ed"],['__file',"src/components/chapter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "504717ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('504717ed', __exports__)) {
    console.log('reload')
    api.reload('504717ed', __exports__)
  }
  
  module.hot.accept("./chapter.vue?vue&type=template&id=504717ed&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('504717ed', render)
  })

}


export default __exports__